import React from "react";
import { StyledJobListing } from "./styles";
import { Helmet } from "react-helmet";
import { APP_DOMAIN } from "../../../../src/shared/constants";

const CommunityManagerJobListing = () => {
  return (
    <>
      <Helmet>
        <title>We’re hiring one amazing Community Lead at Sudowrite</title>
        <meta
          property="og:title"
          content="We’re hiring one amazing Community Lead at Sudowrite"
        />
        <meta
          name="description"
          content="Dream job for anyone who loves writing and community."
        />
        <meta
          name="twitter:title"
          content="We’re hiring one amazing Community Lead at Sudowrite"
        />
        <meta
          name="twitter:description"
          content="Dream job for anyone who loves writing and community."
        />
        <meta
          property="og:description"
          content="Dream job for anyone who loves writing and community."
        />

        <meta
          property="og:image"
          content={`https://${APP_DOMAIN}/assets/community.png`}
        />
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:image"
          content={`https://${APP_DOMAIN}/assets/community.png`}
        />
      </Helmet>
      <StyledJobListing>
        <div className="paper-texture">
          <section id="hero">
            <h3>~ HELP WANTED ~</h3>
            <span id="desktop-header">
              <h1>Will you be our</h1>
              <h1 style={{ fontSize: "15vw" }}>new mayor?</h1>
            </span>
            <span id="mobile-header">
              <h1 id="line1">Will you be</h1>
              <h1 id="line2">our new</h1>
              <h1 id="line3">mayor?</h1>
            </span>
            <h2>Community manager, mayor, champion, gardener. Call it what you will. We’re looking for someone amazing to lead our community to greatness.</h2>
          </section>
          <section id="listing">
            <p>Do you love community strategy & metrics as much as you love writing? Are you energized by helping, welcoming, and empowering others? Then read&nbsp;on...</p>
            <p className="subheader">AI: It’ll either kill us all or create a utopian renaissance situation like the world has never seen.</p>
            <p>
              We’re working really hard to make sure it’s the latter.
              <br /> <br />
              We make this thing called Sudowrite. It’s the best tool for long-form writers ever made. <span className="emphasis">Over 8,000 authors depend on it</span> to publish novels, screenplays,
              short stories, and lots of other things.
              <br /> <br />
              Our writers tell us it helps them write 2-3&#215; as fast, get unblocked, and finish novels that had languished for years. If G.R.R. Martin had this thing, book six would have been out
              years ago.
            </p>
            <p className="subheader">We’re growing fast. We 5Xed revenue and customers in the last six months. We have something real here.</p>
            <p>
              <span className="emphasis">We’re 💥 profitable</span> 💥. We’ve hit product-market fit and now we’re just trying to keep up with demand. Our team is small (just 5) and we’re all really
              good at what we do. We’ve been featured in <a href="https://www.newyorker.com/culture/cultural-comment/the-computers-are-getting-better-at-writing">The New Yorker</a> and lots of other
              places you’ve heard of. Just last month, a book written using Sudowrite was reviewed in the New York Times.
              <br /> <br />
              Our company was started by repeat founders, both writers, both down-to-earth, decent people with prior exits. Our{" "}
              <a href="https://techcrunch.com/2021/11/19/sudowrite-fundraising/?guccounter=1">investors aren’t too shabby, either</a>.
              <br />
              <br />I you’ve played the startup game before, you know that nothing in life is certain. That said, we have strong fundamentals, we believe AI is here to stay, and{" "}
              <span className="emphasis">our business is working</span>.
            </p>
            <p className="subheader">Our community is core to our success. In fact, the vast majority of people find us through word of mouth.</p>
            <p>
              Authors hear about us in discords and slacks and facebook groups and subreddits. We have a <span className="emphasis">friendly Slack community with over 3,500 people</span>. Every day,
              members help each other learn how to use the Sudowrite.
              <br /> <br />
              We have a fledgling <span className="emphasis">ambassadors program</span> with volunteers from all over the world. They hold Zoom sessions to help other authors, answer questions in
              Slack, and document best practices. They are amazing.
              <br /> <br />
              We also build features with dozens and sometimes hundreds of community members giving feedback directly to our product team.{" "}
              <span className="emphasis">We talk to and learn from our customers daily</span>.
            </p>

            <p className="subheader">Community isn’t a nice-to-have, it’s part of our product.</p>
            <p>
              We want our community to become THE reason people choose to join Sudowrite. We want a supportive, ambitious, and vibrant community that is as much the product as the app itself. <br />{" "}
              <br />
              These days, Ryan (our designer) runs weekly community calls, teaches classes on how to use Sudowrite, and works with our ambassadors.
              <br /> <br />
              James (one of our founders) and Josh (one of our engineers) worked closely with hundreds community testers to build our newest feature.
              <br /> <br />
              Amit (the other founder) actively answers questions about sudowrite on reddit and facebook, and is helping with ambassadors.
              <br /> <br />
              And all of us actively answer questions in the community Slack and solicit feedback.
            </p>
            <p className="subheader">We believe a stronger community = a&nbsp;stronger business</p>
            <p>
              We believe great stories change minds & thus change the world.
              <br /> <br />
              We believe tools like Sudowrite are enabling a creative renaissance.
              <br /> <br />
              We believe learning from and supporting each other is the key to making this all work.
              <br /> <br />
              <span className="emphasis">We believe a stronger community directly leads to a stronger business.</span>
            </p>
            <h2>
              Here’s where
              <br />
              you come in…
            </h2>
            <p>
              We want a visionary, compassionate, detail-oriented do-er who can own all aspects of community. Someone who loves trying new things, moves quickly, and wakes up each morning energized by
              this stuff.
              <br /> <br />
              Right now, we believe community encompasses talking with current and future customers, content marketing, and program management, but this may evolve as we learn more about what our
              community members need most.
            </p>

            <p className="subheader">What you’ll do</p>
            <ul>
              <li>Work directly with our founders to create, then own our community strategy</li>
              <li>Establish and monitor key metrics + reporting systems representing our community health</li>
              <li>Grow our community and optimize the funnel from community to customer</li>
              <li>Oversee and improve our educational system - including live classes and youtube videos</li>
              <li>Oversee content - including docs, blogs, emails, and collaborating with external content creators</li>
              <li>Grow our ambassador program - empowering our best writers to share their gifts</li>
              <li>Facilitate community involvement in product decisions</li>
              <li>Maintain a great vibe in our community spaces</li>
              <li>
                Maintain presence wherever writers talk about us - facebook, discords, subreddits, etc. <i>(up for discussion)</i>
              </li>
            </ul>
            <p className="subheader">This is your dream job if you…</p>
            <ul>
              <li>Live and breath community and care deeply about people</li>
              <li>Bring a quantitative mindset to community growth</li>
              <li>Love to set and deliver on ambitious goals</li>
              <li>Love to write and have participated in writer communities</li>
              <li>Are motivated by our mission and vision for the future</li>
              <li>Are able to manage multiple projects with high attention to detail</li>
            </ul>
            <p className="subheader">Required experience</p>
            <ul>
              <li>4-6 years of community experience</li>
              <li>Experience growing an early customer base or community</li>
            </ul>
            <p className="subheader">Things you may have done</p>
            <ul>
              <li>Built an online community with over 1000 members</li>
              <li>Run online or in-person events</li>
              <li>Operated a writing community, workshop, or taught writing</li>
              <li>Been part of the early growth stage of a successful startup in a growth, marketing, product, community management, or operations role</li>
            </ul>
            <p className="subheader">Other things to know</p>
            <ol>
              <li>
                <span className="emphasis"> Remote-first</span>- We’re fully and unapologetically remote. Heck, no two people even live in the same city. We meet up a few times a year, the last few
                times in Yosemite&nbsp;🏞 , the Hudson valley&nbsp;🗽, and Hawaii&nbsp;🌴. We hang out on Zoom on Thursdays and have a monthly book club.
              </li>
              <li>
                <span className="emphasis">Work-life balance</span>- We don’t expect you to spend 80 hours a week at your desk, and we don’t plan to, either. Sometimes things get busy, but it
                shouldn’t be the norm. We have lives outside of work, and we want you to as well.
              </li>
              <li>
                <span className="emphasis">Competitive compensation & benefits</span>- We’ll pay you $80K-100K base salary and give you 0.4-0.5% equity. We’ll help you set up your home office, and
                you’ll have good health and dental insurance and unlimited paid time off (vacation, sick, holidays). Also, all the books you want.
              </li>
            </ol>
            <p className="subheader">Okay, you got me. How do I apply?</p>
            <ul>
              <li>
                <strong>step 1</strong>: Email us at{" "}
                <strong>
                  <a href="mailto:careers@sudowrite.com">careers@sudowrite.com</a>
                </strong>
                . Tell us why this is your dream job, why you’re our dream community person, and send us any relevant work.
              </li>
              <li>
                <strong>step 2</strong>: We’ll carefully review your application and either do a 30 minute call or kindly thank you for applying and feel really bad if it’s not a fit but that’s just
                how it goes sometimes.
              </li>
              <li>
                <strong>step 3</strong>: If you’re both into it, you’ll do a short assignment
              </li>
              <li>
                <strong>step 4</strong>: We’ll chat with your references
              </li>
              <li>
                <strong>step 5</strong>: You’ll meet the rest of the team over Zoom
              </li>
              <li>
                <strong>step 6</strong>: 🎉
              </li>
            </ul>
            <br />
            <br />
            <p style={{ textAlign: "center" }}>We can’t wait to meet you!</p>
          </section>
        </div>
      </StyledJobListing>
    </>
  );
};

export default CommunityManagerJobListing;
